import { render, staticRenderFns } from "./NotificationTemplateBody.vue?vue&type=template&id=2791e053&"
import script from "./NotificationTemplateBody.vue?vue&type=script&lang=ts&"
export * from "./NotificationTemplateBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports